import { MapPin, Phone, Mail } from "lucide-react";

const links = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Fleet", href: "#fleet" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#081132] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg inline-flex items-center px-3 py-2 shadow-md mb-5">
              <img
                src="/brand/rydey-logo.png"
                alt="Rydey - All Day Everyday"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-white/65 text-[14px] leading-relaxed">
              South India's most trusted corporate transportation partner. Powered by
              technology, built on reliability.
            </p>
            <div className="mt-5 text-[11.5px] text-white/45 tracking-wider uppercase font-semibold">
              A brand of Lagnitta Technologies Pvt Ltd
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[12px] font-bold tracking-[0.2em] text-[#F5A623] uppercase mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-white/75 hover:text-[#F5A623] transition-colors text-[14px]"
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[12px] font-bold tracking-[0.2em] text-[#F5A623] uppercase mb-5">
              Services
            </h4>
            <ul className="space-y-3 text-white/75 text-[14px]">
              <li>Employee Cab Services</li>
              <li>Fleet Management</li>
              <li>Automated Scheduling</li>
              <li>Airport & Hotel Transfers</li>
              <li>Corporate Dashboard</li>
            </ul>
          </div>

          {/* Address */}
          <div>
            <h4 className="text-[12px] font-bold tracking-[0.2em] text-[#F5A623] uppercase mb-5">
              Reach Us
            </h4>
            <ul className="space-y-4 text-[14px]">
              <li className="flex gap-3 text-white/75">
                <MapPin size={18} className="text-[#F5A623] mt-0.5 shrink-0" />
                <span>
                  Bldg No: 99, GVVG+JC3, 2403, VSSC Rd, Kulathoor,
                  Thiruvananthapuram, Kerala 695582
                </span>
              </li>
              <li>
                <a
                  href="tel:+917012998898"
                  className="flex gap-3 text-white/75 hover:text-[#F5A623] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={18} className="text-[#F5A623] mt-0.5 shrink-0" />
                  +91 7012998898
                </a>
              </li>
              <li>
                <a
                  href="mailto:support@rydey.in"
                  className="flex gap-3 text-white/75 hover:text-[#F5A623] transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={18} className="text-[#F5A623] mt-0.5 shrink-0" />
                  support@rydey.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-7 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[13px]">
          <div className="text-white/55">
            © 2024 Lagnitta Technologies Pvt Ltd. All rights reserved.
          </div>
          <div className="text-white/45 tracking-wide flex items-center gap-4">
            <span>Backed by Kerala Startup Mission · Thiruvananthapuram, India</span>
            <a href="/admin" className="text-white/30 hover:text-[#F5A623] transition-colors text-[11px] tracking-[0.16em] uppercase" data-testid="footer-admin-link">
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
